import React from 'react';
import usePrevious from '../../../../Hooks/usePrevious';
import sendNotification from '../../../../notifications/sendNotification';
import { useUserInfoData } from '../../../Hooks/useUserInfo';
import useIsWindowVisible from '../../Hooks/useIsWindowVisible';
import useContentMaps from '../../Hooks/useSession/useContentMaps';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';

export default function useDetectionNotifications() {
  const { latestDetection: [latestDetection] } = useSessionStoreContext();

  const notificationSettings = useUserInfoData().appSettings?.notifications;
  const { isVisible } = useIsWindowVisible();
  const { cardTitleMap, commandTitleMap } = useContentMaps(latestDetection?.projectId);

  const previousDetectionId = usePrevious(latestDetection?.id);
  React.useEffect(() => {
    if (latestDetection?.id !== previousDetectionId) {
      if (latestDetection && latestDetection?.cardId && notificationSettings?.notifyOnDetection) {
        sendNotification({
          type: 'detection',
          cardTitle: cardTitleMap.get(latestDetection.cardId),
          commandTitle: commandTitleMap.get(latestDetection.commandId),
        });
      }
    }
  }, [latestDetection, previousDetectionId, notificationSettings?.notifyOnDetection, cardTitleMap, commandTitleMap]);

  const [badgeCount, setBadgeCount] = React.useState(0);

  React.useEffect(() => {
    if (isVisible) {
      setBadgeCount(0);
    }
  }, [isVisible]);

  React.useEffect(() => {
    if (latestDetection && !isVisible) {
      setBadgeCount((prev) => prev + 1);
    }
  }, [latestDetection]);

  React.useEffect(() => {
    (navigator as any).setAppBadge(badgeCount);
  }, [badgeCount]);
}
